import { observer } from "mobx-react";
import React from "react";
import {
  Center,
  Loader,
  Modal,
  Stack,
  Image,
  Text,
  Group,
  Button,
} from "@mantine/core";

import { BOB_MODALS } from "../../helpers/constants";
import { Bob } from "../../stores/Bob";
import { MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS } from "../../../helpers/constants";
import BobNostrConnectionCard from "../nwc/bobNostrConnectionCard";
import { IconPlus, IconRefresh } from "@tabler/icons-react";
import { CustomModalTitle } from "../details/customModalTitle";

const MAX_SEND_AND_RECEIVE_CONNECTIONS = 10;

const NwcModalSecure = observer(({ bob }: { bob: Bob }) => {
  const handleClose = () => {
    bob.setOpenModal(null);
    bob.purgeNostrConnections();
    // so user doesnt see stale 2fa box
    bob.checkIfWeNeedToShowTwoFactorForm();
  };
  const { nostrConnectionsAreRefreshing } = bob;
  const connections = bob.sendAndReceiveNostrConnectionsOrderedByCreatedAtDesc;
  return (
    <Modal
      opened={bob.openModal === BOB_MODALS.NWC_SECURE}
      onClose={handleClose}
      size={MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS}
      title={
        <CustomModalTitle
          text="Get NWC Codes"
          icon={
            <Image
              src="https://daxwktpz4hkwd.cloudfront.net/nwc_logos/nwc-square-color-two.png"
              alt="NWC Logo"
              w={16}
              h={16}
              fit="contain"
              style={{ flexShrink: 0, marginTop: 2 }}
            />
          }
        />
      }
    >
      <Stack>
        {nostrConnectionsAreRefreshing && (
          <Loader
            size="xl"
            variant="dots"
            style={{ marginTop: 20, marginBottom: 20 }}
          />
        )}

        {!nostrConnectionsAreRefreshing && (
          <>
            <Center>
              <Image
                w={200}
                src="https://daxwktpz4hkwd.cloudfront.net/nwc_logos/nwc-horizontal-with-text-color.png"
                alt="NWC Logo"
              />
            </Center>

            <Text>
              You can send and receive payments using external apps with{" "}
              <strong>Nostr Wallet Connect</strong>. This is experimental
              technology. Please only use this with apps and websites that you
              trust.
            </Text>

            {connections.length >= MAX_SEND_AND_RECEIVE_CONNECTIONS && (
              <Text>
                You've reached the maximum number of connections. Please delete
                an existing connection to add a new one.
              </Text>
            )}

            {connections.map((connection) => (
              <BobNostrConnectionCard
                key={connection.uuid}
                connection={connection}
                bob={bob}
              />
            ))}
            <Group justify="center">
              {connections.length < MAX_SEND_AND_RECEIVE_CONNECTIONS && (
                <Button
                  leftSection={<IconPlus />}
                  variant="default"
                  onClick={() => bob.updateNostrConnections("create-new", null)}
                >
                  New Connection
                </Button>
              )}

              <Button
                leftSection={<IconRefresh />}
                variant="default"
                onClick={() => bob.updateNostrConnections("refresh-all", null)}
              ></Button>
            </Group>
          </>
        )}
      </Stack>
    </Modal>
  );
});

export default NwcModalSecure;
